import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { useMutation } from '@tanstack/react-query';
import { memo, useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ScheduleExpectationRepository from '@/repositories/ScheduleExpectationRepository';
import { DropdownMenuItem } from '@/ui/DropdownMenu/DropdownMenu';

interface Props {
  personId: string;
}

const RecomputeCyclesButton = ({ personId }: Props) => {
  const { addMessage } = useContext(AppContext);
  const scheduleExpectationRepository = ScheduleExpectationRepository();

  const recomputeCycles = useMutation({
    mutationFn: () =>
      scheduleExpectationRepository.recomputeScheduleExpectationsForPerson({ personId }),
    onSuccess: () => {
      addMessage({
        level: 'success',
        text: 'Triggered recompute schedule expectation cycles. Current cycles will be updated automatically'
      });
    },
    onError: () => {
      addMessage({ level: 'error', text: 'Error recomputing schedule expectations' });
    }
  });

  return (
    <DropdownMenuItem
      icon={faRefresh}
      disabled={recomputeCycles.isPending}
      onClick={() => recomputeCycles.mutate()}>
      {recomputeCycles.isPending ? 'Recomputing...' : 'Recompute'}
    </DropdownMenuItem>
  );
};

export default memo(RecomputeCyclesButton);
